import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import { injectIntl } from 'react-intl';
import { Popup, Icon } from 'semantic-ui-react';
import getSymbolFromCurrency from 'currency-symbol-map';
import { classNames } from 'utilities/css';
import DesktopAddOnsRow from './desktop-row';
import MobileAddOnsRow from './mobile-row';
import styles from '../styles-module.css';
import { SMALL_DEVICE_BREAK_POINT } from '../../consts';
import { locale } from '../locale';

const AddOnRow = injectIntl((props) => {
  const { intl, addOn, handleOnAddOnsDelete, handleOnAddOnsStatusChange } = props;
  const [ isDisabled, setIsDisabled ] = useState(false);
  const [ isAllSoldOut, setIsAllSoldOut ] = useState(false);

  const formatPrices = () => {
    return addOn?.rates?.map((r) => {
      const text = r.price === 0
        ? intl.formatMessage(locale.free)
        : `${getSymbolFromCurrency(addOn?.currency).charAt(0)}${r.price} ${addOn?.currency}`;

      return <div className={styles.option} key={r.id}>{text}</div>;
    });
  }

  const tooltipStyle = {
    borderRadius: '5px',
    background: 'var(--color-ink)',
    padding: '8px 8px',
    maxWidth: '327px',
    left: '20px',
  };

  const formatAvailable = () => {
    const ratesLength = addOn?.rates?.length;
    let soldRateText;
    let soldOutRates = 0;
    if (ratesLength === 1) {
      soldRateText = intl.formatMessage(locale.allRatesSold)
    } else {
      soldRateText = intl.formatMessage(locale.multiRatesSold)
    }

    const rateList = addOn?.rates?.map(r => {
      let text;
      let style = '';

      if (r.availability === 0) {
        text = `${r.availability}/${r.capacity}`;
        style = styles.soldOutColor;
        soldOutRates += 1;
        setIsDisabled(true);
      }
      else if (!r.availability) {
        text = intl.formatMessage(locale.unlimited);
        setIsDisabled(false);
      }
      else {
        text = `${r.availability}/${r.capacity}`;
        setIsDisabled(false);
      }

      return (<div>
        {
          r.availability === 0
          ? <Popup
              content={soldRateText}
              trigger={
                <div style={{display: 'flex'}}>
                  <Icon className={classNames('universe-error', styles.iconStyle)} />
                  <div className={`${styles.option} ${style}`} key={r.id}>
                    {text}
                  </div>
                </div>
              }
              style={tooltipStyle}
              position="top center"
              inverted
              basic
            />
          : <div className={`${styles.option} ${style}`} key={r.id}>
              {text}
            </div>
        }
        </div>);
    });

    if (soldOutRates === ratesLength) {
      setIsAllSoldOut(true);
    } else {
      setIsAllSoldOut(false);
    }

    return rateList;
  }

  return (
    <div className={`${styles.addOnRow}`} key={addOn}>
      <MediaQuery minWidth={SMALL_DEVICE_BREAK_POINT + 1}>
        <DesktopAddOnsRow
          onAddOnsStatusChange={handleOnAddOnsStatusChange}
          onAddOnsDelete={handleOnAddOnsDelete}
          formatPrices={() => formatPrices()}
          formatAvailable={() => formatAvailable()}
          isDisabled={isDisabled}
          isAllSoldOut={isAllSoldOut}
          {...props}
        />
      </MediaQuery>
      <MediaQuery maxWidth={SMALL_DEVICE_BREAK_POINT}>
        <MobileAddOnsRow
          onAddOnsStatusChange={handleOnAddOnsStatusChange}
          onAddOnsDelete={handleOnAddOnsDelete}
          formatPrices={() => formatPrices()}
          formatAvailable={() => formatAvailable()}
          isDisabled={isDisabled}
          isAllSoldOut={isAllSoldOut}
          {...props}
        />
      </MediaQuery>
    </div>
  )
});

export default AddOnRow;
